import React, { ReactNode, useEffect, useRef } from 'react';

const Focus = ({ children }: { children: ReactNode }) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const header = ref.current?.querySelector('h1');
    if (header) {
      header.tabIndex = -1;
      header.focus();
    }
  }, []);

  return <div ref={ref}>{children}</div>;
};

export default Focus;
